import { useCallback, useState } from 'react';

import { Input } from '@/lib/base/forms/input/input';
import { getPropertyTypeIconComponent } from '@/lib/crm/utils/icons/PropertyTypeIcon';

import type { PropertyInputProps } from './TextInput';

const EMAIL_ERROR_MESSAGE =
  "This email address isn't valid – Check that it's formatted correctly and try again.";
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  inputRef,
  placeholder,
  trailingAddon,
  size = 'sm',
}) => {
  const [isTouched, setIsTouched] = useState(false);
  const Icon = getPropertyTypeIconComponent(propertyType);
  const stringValue = (value as string) || '';
  const trimmedValue = stringValue.trim();
  const hasError = trimmedValue.length > 0 && !EMAIL_REGEX.test(trimmedValue);
  const showError = isTouched && hasError;

  const handleBlur = useCallback(() => {
    setIsTouched(true);
  }, []);

  return (
    <Input
      type='email'
      value={stringValue}
      onChange={onChange}
      onBlur={handleBlur}
      isInvalid={showError}
      hint={showError ? EMAIL_ERROR_MESSAGE : undefined}
      isDisabled={disabled}
      icon={Icon}
      size={size}
      aria-label={propertyType.label}
      ref={inputRef}
      placeholder={placeholder}
      trailingAddon={trailingAddon}
    />
  );
};
